import React, { useEffect, useRef, useState } from "react";
import { FormControl, InputGroup } from "react-bootstrap";
import { toEnDateString } from "../../../../utils/dateUtils";
import { formatModel, format as formatData } from "../format";

export function InputCustom({
  ele,
  val,
  changeValue,
  leftTemplate,
  rightTemplate,
  alignRight,
  ...rest
}) {
  const [extraDataFormat, setExtraData] = useState({});
  const debounceTimeoutRef = useRef();
  const formatByNumber = (date) => toEnDateString(date);
  const formatByString = (date) => date.split("T")[0];
  const calcDateFormat = (value) => {
    return value && typeof value === "string" && value.indexOf("T") !== -1
      ? formatByString(value.split("T")[0])
      : value &&
        typeof value === "string" &&
        /^\d+$/.test(value) &&
        parseInt(value)
      ? formatByNumber(parseInt(value))
      : value;
  };
  const getFormatModel = (value) => {
    const d = formatModel(ele.format, value, extraDataFormat);
    setExtraData(d.extraData);
    return d.value;
  };
  const getFormatData = (currentValue = value) => {
    return formatData(ele.format, currentValue, extraDataFormat);
  };
  const externalValue = ele?.dataElement?.type === "date" ? calcDateFormat(val) : val;
  const isFileInput = ele?.dataElement?.type === "file";
  const isDebounced = Number(ele?.debounce) > 0;
  const value = externalValue;
  const [inputValue, setInputValue] = useState(
    isFileInput
      ? externalValue?.value || ""
      : ele.format
      ? getFormatData(externalValue)
      : externalValue ?? ""
  );

  useEffect(() => {
    setInputValue(
      isFileInput
        ? externalValue?.value || ""
        : ele.format
        ? getFormatData(externalValue)
        : externalValue ?? ""
    );
  }, [externalValue, isFileInput, ele.format]);

  useEffect(() => {
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, []);

  const applyChangeValue = (nextValue) => {
    if (!isDebounced) {
      changeValue(nextValue);
      return;
    }

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      changeValue(nextValue);
    }, Number(ele.debounce));
  };

  const blurHandler = () => {
    const blurRawValue = isFileInput ? inputValue?.value : inputValue;

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
      debounceTimeoutRef.current = undefined;
    }

    if (isDebounced && !isFileInput) {
      const blurValue = ele.format ? getFormatModel(inputValue) : inputValue;
      changeValue(blurValue);
    }

    if (
      ele.min !== undefined &&
      (isNaN(parseFloat(blurRawValue)) || ele.min > parseFloat(blurRawValue))
    ) {
      changeValue(ele.min);
    }
  };
  return (
    <InputGroup className="">
      {leftTemplate && (
        <InputGroup.Text id="basic-addon-left">{leftTemplate}</InputGroup.Text>
      )}
      <FormControl
        autoComplete="off"
        autocorret="off"
        role="presentation"
        autofill="off"
        aria-autocomplete="both"
        disabled={ele.disabled}
        className={alignRight ? "text-right" : ""}
        type="text"
        name={ele.name}
        onBlur={blurHandler}
        onChange={(event) => {
          setInputValue(event.target.value);

          const value =
            isFileInput
              ? {
                  file: event.target?.files[0],
                  value: event.target.value,
                }
              : ele.format
              ? getFormatModel(event.target.value)
              : event.target.value;
          applyChangeValue(value);
        }}
        value={inputValue}
        {...(ele?.dataElement || {})}
        {...rest}
      />
      {rightTemplate && (
        <InputGroup.Text id="basic-addon-right">
          {rightTemplate}
        </InputGroup.Text>
      )}
    </InputGroup>
  );
}
